export default {
  /** 自定义标签列表 */
  tagList: '/api/tag/config/list',
  /** 自定义标签更新（新增/删除） */
  createOrUpdate: '/api/tag/config/createOrUpdate',
  /** 校验tag是否使用中 */
  validateTagInUse: '/api/tag/config/valid_list',
}
